import { api } from '../middleware/api';
import { sseClient } from '../../services/sseClient';

// Define endpoints using injectApi pattern
export const notificationsApi = api
  .enhanceEndpoints({ addTagTypes: ['ANotifications'] })
  .injectEndpoints({
    endpoints: builder => ({
      getANotificationss: builder.query<bt_enotifications[], void>({
        query: () => `notification`,
        providesTags: ['ANotifications'],
        async onCacheEntryAdded(
          _arg,
          { cacheDataLoaded, cacheEntryRemoved, dispatch }
        ) {
          try {
            await cacheDataLoaded;
            const unsubscribe = sseClient.addListener(data => {
              if (data.type === 'NOTIFICATION_ADDED') {
                dispatch(
                  notificationsApi.util.invalidateTags(['ANotifications'])
                );
              }
            });
            await cacheEntryRemoved;
            unsubscribe();
          } catch {
            // no-op
          }
        }
      }),
      getANotificationsByUser: builder.query<bt_enotifications[], void>({
        query: () => `notification/byuser`,
        providesTags: ['ANotifications'],
        async onCacheEntryAdded(
          _arg,
          { cacheDataLoaded, cacheEntryRemoved, dispatch }
        ) {
          try {
            await cacheDataLoaded;
            const unsubscribe = sseClient.addListener(data => {
              if (data.type === 'NOTIFICATION_ADDED') {
                dispatch(
                  notificationsApi.util.invalidateTags(['ANotifications'])
                );
              }
            });
            await cacheEntryRemoved;
            unsubscribe();
          } catch {
            // no-op
          }
        }
      }),
      getANotifications: builder.query<bt_enotifications, string>({
        query: id => `notification/byid/${id}`
      }),
      insertANotifications: builder.mutation({
        query: notification => ({
          url: `notification/`,
          method: 'POST',
          body: notification
        }),
        invalidatesTags: ['ANotifications']
      }),
      updateANotifications: builder.mutation({
        query: notification => ({
          url: `notification/`,
          method: 'PUT',
          body: notification
        }),
        invalidatesTags: ['ANotifications']
      }),
      deleteANotifications: builder.mutation({
        query: notification => ({
          url: `notification/${notification.nt_id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['ANotifications']
      })
    }),
    overrideExisting: true
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetANotificationssQuery,
  useGetANotificationsByUserQuery,
  useGetANotificationsQuery,
  useInsertANotificationsMutation,
  useUpdateANotificationsMutation,
  useDeleteANotificationsMutation
} = notificationsApi;

